import { render, staticRenderFns } from "./UpdatePaymentMethod.vue?vue&type=template&id=68da6dce&scoped=true"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=ts"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePaymentMethod.vue?vue&type=style&index=0&id=68da6dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da6dce",
  null
  
)

export default component.exports